/* FineBush — Theme JS */
(function () {
  // Blog/Journal grid — ‘See more’ toggle.
  // The Liquid section renders the first N posts visible and the rest with the
  // .blog-card--hidden class. Clicking the toggle adds .blog-grid--expanded to
  // the grid (which un-hides everything via CSS) and swaps the button label.
  document.querySelectorAll('[data-blog-grid]').forEach(function (grid) {
    var toggleBtn = grid.parentElement && grid.parentElement.querySelector('[data-blog-toggle]');
    if (!toggleBtn) return;
    var labelEl = toggleBtn.querySelector('[data-blog-toggle-label]');
    var moreLabel = toggleBtn.dataset.labelMore || 'See more';
    var lessLabel = toggleBtn.dataset.labelLess || 'Show fewer';

    toggleBtn.addEventListener('click', function () {
      var expanded = grid.classList.toggle('blog-grid--expanded');
      grid.classList.toggle('blog-grid--collapsed', !expanded);
      toggleBtn.setAttribute('aria-expanded', String(expanded));
      if (labelEl) labelEl.textContent = expanded ? lessLabel : moreLabel;
      // Reveal hidden cards to assistive tech when expanded.
      grid.querySelectorAll('.blog-card--hidden').forEach(function (card) {
        if (expanded) {
          card.removeAttribute('aria-hidden');
        } else {
          card.setAttribute('aria-hidden', 'true');
        }
      });
      if (!expanded) {
        // Collapsing: scroll the grid back into view so the user isn’t left at the bottom.
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Mobile nav toggle
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  // Quantity controls
  document.querySelectorAll('.qty').forEach((q) => {
    const input = q.querySelector('input');
    const dec = q.querySelector('[data-qty="dec"]');
    const inc = q.querySelector('[data-qty="inc"]');
    if (!input) return;
    if (dec) dec.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (inc) inc.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  // Newsletter — block submit if empty (Shopify handles real submission)
  document.querySelectorAll('form[data-newsletter]').forEach((f) => {
    f.addEventListener('submit', (e) => {
      const input = f.querySelector('input[type="email"]');
      if (input && !input.value.trim()) {
        e.preventDefault();
        input.focus();
      }
    });
  });

  // Announcement carousel
  document.querySelectorAll('[data-announcement-carousel]').forEach((root) => {
    const msgs = Array.from(root.querySelectorAll('[data-announcement-msg]'));
    if (msgs.length < 2) return;
    const interval = Math.max(2000, parseInt(root.dataset.announcementInterval || '7000', 10));
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let idx = 0;
    const go = (n) => {
      msgs.forEach((m, i) => m.classList.toggle('is-active', i === n));
      idx = n;
    };
    go(0);
    if (reduce) return;
    let timer = setInterval(() => go((idx + 1) % msgs.length), interval);
    root.addEventListener('mouseenter', () => { clearInterval(timer); timer = null; });
    root.addEventListener('mouseleave', () => { if (!timer) timer = setInterval(() => go((idx + 1) % msgs.length), interval); });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { clearInterval(timer); timer = null; }
      else if (!timer) timer = setInterval(() => go((idx + 1) % msgs.length), interval);
    });
  });

  // Hero carousel
  document.querySelectorAll('[data-hero-carousel]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    const prev = root.querySelector('[data-hero-prev]');
    const next = root.querySelector('[data-hero-next]');
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;

    const go = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const active = k === index;
        s.classList.toggle('is-active', active);
        if (active) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach((d, k) => {
        const active = k === index;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', String(active));
      });
    };

    if (prev) prev.addEventListener('click', () => { go(index - 1); restart(); });
    if (next) next.addEventListener('click', () => { go(index + 1); restart(); });
    dots.forEach((d) => d.addEventListener('click', () => {
      const target = parseInt(d.getAttribute('data-hero-dot'), 10);
      if (!Number.isNaN(target)) { go(target); restart(); }
    }));

    // Keyboard
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { go(index - 1); restart(); }
      if (e.key === 'ArrowRight') { go(index + 1); restart(); }
    });

    // Autoplay
    const autoplay = root.dataset.heroAutoplay !== 'false' && !prefersReduced;
    const intervalMs = Math.max(4000, (parseInt(root.dataset.heroInterval, 10) || 7) * 1000);
    let timer = null;
    const start = () => { if (autoplay && !timer) timer = setInterval(() => go(index + 1), intervalMs); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const restart = () => { stop(); start(); };

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

    start();
  });

  // Subtle in-view fade
  // v9 fix: hero copy uses CSS transform for xshift/yshift nudges from
  // section settings. If we ALSO write inline `transform: translateY(...)`
  // on the fade, JS overwrites the nudge and it looks like the setting
  // reverted on save. Skip the transform part of the fade for hero copy.
  const io = ('IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        if (!e.target.classList.contains('hero__copy')) {
          e.target.style.transform = 'translateY(0)';
        }
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 }) : null;
  if (io) {
    document.querySelectorAll('[data-fade]').forEach((el) => {
      el.style.opacity = '0';
      if (el.classList.contains('hero__copy')) {
        el.style.transition = 'opacity .7s ease';
      } else {
        el.style.transform = 'translateY(16px)';
        el.style.transition = 'opacity .7s ease, transform .7s ease';
      }
      io.observe(el);
    });
  }
})();

// Store locator — runs independently at module scope
(function initLocator() {
    const root = document.querySelector('[data-locator]');
    if (!root) return;
    if (typeof L === 'undefined') {
      // Leaflet not loaded yet — try again shortly
      setTimeout(initLocator, 200);
      return;
    }
    const mapEl = root.querySelector('#locator-map');
    const listEl = root.querySelector('[data-locator-list]');
    const rows = Array.from(root.querySelectorAll('[data-locator-row]'));
    const searchInput = root.querySelector('[data-locator-search]');
    const filterSelect = root.querySelector('[data-locator-filter]');
    const emptyEl = root.querySelector('[data-locator-empty]');
    if (!mapEl || !rows.length) return;

    const stores = rows.map((row) => ({
      el: row,
      id: row.dataset.id,
      name: row.dataset.name,
      address: row.dataset.address,
      district: row.dataset.district,
      type: row.dataset.type,
      hours: row.dataset.hours || '',
      lat: parseFloat(row.dataset.lat),
      lng: parseFloat(row.dataset.lng),
    }));

    const pinSvg = (color) => `<svg viewBox="0 0 28 38" xmlns="http://www.w3.org/2000/svg"><path d="M14 1C6.8 1 1 6.8 1 14c0 9.5 13 23 13 23s13-13.5 13-23C27 6.8 21.2 1 14 1z" fill="${color}" stroke="#2F2A26" stroke-width="1.3"/><circle cx="14" cy="14" r="4.5" fill="#F6E8DB"/></svg>`;
    const makeIcon = (active) => L.divIcon({
      className: 'finebush-pin',
      html: pinSvg(active ? '#D96052' : '#91AA82'),
      iconSize: [28, 38],
      iconAnchor: [14, 36],
      popupAnchor: [0, -32],
    });

    const map = L.map(mapEl, {
      zoomControl: true,
      scrollWheelZoom: false,
      attributionControl: true,
    });
    // Warm, light basemap from CartoDB
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19,
    }).addTo(map);

    const markers = {};
    let activeId = null;

    stores.forEach((s) => {
      if (isNaN(s.lat) || isNaN(s.lng)) return;
      const m = L.marker([s.lat, s.lng], { icon: makeIcon(false), title: s.name }).addTo(map);
      const addrHtml = s.address.replace(/\n/g, '<br>');
      const popup = `
        <h3>${s.name}</h3>
        <p class="popup-addr">${addrHtml}</p>
        ${s.hours ? `<p class="popup-meta">${s.hours}</p>` : ''}
        <a class="popup-btn" target="_blank" rel="noopener"
           href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(s.address.replace(/\n/g, ', '))}">
          Directions
        </a>`;
      m.bindPopup(popup, { closeButton: true, autoPanPadding: [40, 40] });
      m.on('click', () => setActive(s.id, { zoom: true, openPopup: false }));
      markers[s.id] = m;
    });

    // Fit the map to markers
    const group = L.featureGroup(Object.values(markers));
    if (group.getLayers().length) map.fitBounds(group.getBounds().pad(0.15));
    else map.setView([22.32, 114.17], 12);

    function setActive(id, opts = {}) {
      if (activeId && markers[activeId]) markers[activeId].setIcon(makeIcon(false));
      activeId = id;
      rows.forEach((r) => r.classList.toggle('is-active', r.dataset.id === id));
      const m = markers[id];
      if (m) {
        m.setIcon(makeIcon(true));
        if (opts.zoom) map.flyTo(m.getLatLng(), Math.max(map.getZoom(), 14), { duration: 0.8 });
        if (opts.openPopup !== false) m.openPopup();
      }
      const row = rows.find((r) => r.dataset.id === id);
      if (row && opts.scrollList !== false) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    rows.forEach((row) => {
      row.addEventListener('click', () => setActive(row.dataset.id, { zoom: true, openPopup: true, scrollList: false }));
    });

    function applyFilter() {
      const q = (searchInput && searchInput.value || '').trim().toLowerCase();
      const type = (filterSelect && filterSelect.value) || 'all';
      let visible = 0;
      stores.forEach((s) => {
        const matchText = !q
          || s.name.toLowerCase().includes(q)
          || s.address.toLowerCase().includes(q)
          || (s.district || '').toLowerCase().includes(q);
        const matchType = type === 'all' || s.type === type;
        const ok = matchText && matchType;
        s.el.style.display = ok ? '' : 'none';
        if (markers[s.id]) {
          if (ok) markers[s.id].addTo(map);
          else map.removeLayer(markers[s.id]);
        }
        if (ok) visible += 1;
      });
      if (emptyEl) emptyEl.style.display = visible === 0 ? 'block' : 'none';
    }

    if (searchInput) searchInput.addEventListener('input', applyFilter);
    if (filterSelect) filterSelect.addEventListener('change', applyFilter);
})();

/* ---------- Product cards — async add-to-cart ---------- */
(function () {
  const forms = document.querySelectorAll('[data-pc-add-form]');
  if (!forms.length) return;

  // Prepare a single toast element
  let toast = document.querySelector('.pc-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'pc-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }
  let toastTimer = null;
  function showToast(msg) {
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }

  function setButtonState(btn, state) {
    if (!btn) return;
    const labelEl = btn.querySelector('[data-pc-label]');
    const defaultLabel = btn.dataset.defaultLabel || 'Add to cart';
    if (state === 'loading') {
      btn.setAttribute('aria-busy', 'true');
      if (labelEl) labelEl.textContent = 'Adding…';
    } else if (state === 'success') {
      btn.removeAttribute('aria-busy');
      if (labelEl) labelEl.textContent = 'Added ✓';
      setTimeout(() => { if (labelEl) labelEl.textContent = defaultLabel; }, 1800);
    } else if (state === 'error') {
      btn.removeAttribute('aria-busy');
      if (labelEl) labelEl.textContent = 'Try again';
      setTimeout(() => { if (labelEl) labelEl.textContent = defaultLabel; }, 2200);
    } else {
      btn.removeAttribute('aria-busy');
      if (labelEl) labelEl.textContent = defaultLabel;
    }
  }

  function updateCartCount(count) {
    const el = document.querySelector('.cart-count');
    if (el && typeof count === 'number') el.textContent = String(count);
  }

  // Fetch the cart to refresh the count after adding
  async function refreshCount() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
      if (!r.ok) return;
      const data = await r.json();
      if (data && typeof data.item_count === 'number') updateCartCount(data.item_count);
    } catch (_) { /* no-op */ }
  }

  forms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-pc-add-btn]');
      setButtonState(btn, 'loading');

      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        });

        if (!res.ok) {
          // Most common cause: invalid variant id or unpublished product.
          const detail = await res.json().catch(() => ({}));
          setButtonState(btn, 'error');
          showToast(detail.description || 'Could not add to cart.');
          return;
        }

        setButtonState(btn, 'success');
        showToast('Added to cart.');
        refreshCount();
        // Open the cart drawer (and refresh its contents)
        if (window.FBCart && typeof window.FBCart.openAfterAdd === 'function') {
          window.FBCart.openAfterAdd();
        }
      } catch (err) {
        setButtonState(btn, 'error');
        showToast('Network error — please try again.');
      }
    });
  });
})();

/* =========================================================
   v3.4 — Cart drawer controller (slide-out basket)
   Exposes window.FBCart with: open(), close(), refresh(), openAfterAdd()
   ========================================================= */
(function () {
  const root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  const body = root.querySelector('[data-cart-drawer-body]');
  const foot = root.querySelector('[data-cart-drawer-foot]');
  const subtotalEl = root.querySelector('[data-cart-drawer-subtotal]');
  const checkoutBtn = root.querySelector('[data-cart-drawer-checkout]');
  let lastFocus = null;

  // --- Money formatting -----------------------------------------------------
  // Uses Shopify.currency if present, else a sensible default. Cart.js returns
  // prices in cents.
  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    const code =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
      }).format(amount);
    } catch (_) {
      return '$' + amount.toFixed(2);
    }
  }

  // --- Open / close ---------------------------------------------------------
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    // Focus the close button for a11y
    const closeBtn = root.querySelector('.cart-drawer__close');
    if (closeBtn) setTimeout(() => closeBtn.focus(), 60);
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus(); } catch (_) {}
    }
  }

  // --- Rendering ------------------------------------------------------------
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function itemImageUrl(item) {
    // Shopify cart.js returns a protocol-relative image URL (item.image).
    // Request a 160px wide thumbnail using the _{size} suffix convention.
    const raw = item.image || item.featured_image?.url || '';
    if (!raw) return '';
    // Ensure https
    let url = raw.startsWith('//') ? 'https:' + raw : raw;
    // Insert _160x before the extension for a smaller image (best-effort)
    try {
      const m = url.match(/(.+)\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i);
      if (m) return `${m[1]}_160x.${m[2]}${m[3] || ''}`;
    } catch (_) {}
    return url;
  }

  function renderItems(cart) {
    if (!body) return;

    if (!cart || cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty" data-cart-drawer-empty>
          <p class="cart-drawer__empty-title">Your basket is empty.</p>
          <p class="cart-drawer__empty-sub">Pour yourself something lovely — begin in the shop.</p>
          <a class="btn btn--primary cart-drawer__empty-cta" href="/collections/all">Continue shopping</a>
        </div>
      `;
      if (foot) foot.setAttribute('hidden', '');
      if (checkoutBtn) checkoutBtn.setAttribute('aria-disabled', 'true');
      return;
    }

    const itemsHtml = cart.items.map((item, i) => {
      const img = itemImageUrl(item);
      const title = escapeHtml(item.product_title || item.title);
      const variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>`
          : '';
      // Per-product image background (from product.metafields.finebush.image_bg).
      // Missing entries fall through to the CSS default (transparent).
      const bgMap = (window.__fbProductBg || {});
      const bg = bgMap[item.product_id];
      const bgStyle = bg ? ` style="background: ${escapeHtml(bg)};"` : '';
      return `
        <li class="cart-item" data-cart-item data-line="${i + 1}" data-key="${escapeHtml(item.key)}">
          <a href="${escapeHtml(item.url)}" class="cart-item__media" aria-hidden="true" tabindex="-1"${bgStyle}>
            ${img ? `<img src="${escapeHtml(img)}" alt="${title}" loading="lazy" width="80" height="80">` : ''}
          </a>
          <div class="cart-item__body">
            <a href="${escapeHtml(item.url)}" class="cart-item__title">${title}</a>
            ${variant}
            <div class="cart-item__row">
              <div class="cart-item__qty" role="group" aria-label="Quantity">
                <button type="button" class="cart-item__qty-btn" data-cart-qty-dec aria-label="Decrease quantity">−</button>
                <input class="cart-item__qty-input" type="number" min="0" step="1" value="${item.quantity}" data-cart-qty-input aria-label="Quantity for ${title}">
                <button type="button" class="cart-item__qty-btn" data-cart-qty-inc aria-label="Increase quantity">+</button>
              </div>
              <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
            </div>
            <button type="button" class="cart-item__remove" data-cart-remove>Remove</button>
          </div>
        </li>
      `;
    }).join('');

    body.innerHTML = `<ul class="cart-drawer__items" data-cart-drawer-items>${itemsHtml}</ul>`;

    if (foot) foot.removeAttribute('hidden');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (checkoutBtn) checkoutBtn.removeAttribute('aria-disabled');
  }

  function updateHeaderCount(count) {
    const el = document.querySelector('.cart-count');
    if (el && typeof count === 'number') el.textContent = String(count);
  }

  // --- Network --------------------------------------------------------------
  async function fetchCart() {
    const r = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
    });
    if (!r.ok) throw new Error('cart fetch failed');
    return r.json();
  }

  async function changeLine(line, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity }),
    });
    if (!r.ok) throw new Error('cart change failed');
    return r.json();
  }

  async function refresh() {
    try {
      const cart = await fetchCart();
      renderItems(cart);
      updateHeaderCount(cart.item_count);
    } catch (e) {
      // Leave current markup if fetch fails
    }
  }

  // Open and refresh (used by add-to-cart success hook)
  async function openAfterAdd() {
    open();
    await refresh();
  }

  // --- Event delegation -----------------------------------------------------
  // Open from any element with data-cart-drawer-open
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-drawer-open]');
    if (opener) {
      // Intercept only on modern browsers — allow full-page nav if JS fails
      e.preventDefault();
      openAfterAdd();
      return;
    }
    const closer = e.target.closest('[data-cart-drawer-close]');
    if (closer && root.contains(closer)) {
      e.preventDefault();
      close();
    }
  });

  // Escape key to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // Qty and remove — delegated to the drawer body
  let debounceTimers = new WeakMap();

  async function applyLineChange(itemEl, quantity) {
    const line = Number(itemEl.getAttribute('data-line'));
    if (!line) return;
    itemEl.classList.add('is-updating');
    try {
      const cart = await changeLine(line, quantity);
      renderItems(cart);
      updateHeaderCount(cart.item_count);
    } catch (_) {
      itemEl.classList.remove('is-updating');
    }
  }

  body?.addEventListener('click', (e) => {
    const itemEl = e.target.closest('[data-cart-item]');
    if (!itemEl) return;

    if (e.target.closest('[data-cart-qty-inc]')) {
      const input = itemEl.querySelector('[data-cart-qty-input]');
      const next = Math.max(0, (Number(input.value) || 0) + 1);
      input.value = String(next);
      applyLineChange(itemEl, next);
    } else if (e.target.closest('[data-cart-qty-dec]')) {
      const input = itemEl.querySelector('[data-cart-qty-input]');
      const next = Math.max(0, (Number(input.value) || 0) - 1);
      input.value = String(next);
      applyLineChange(itemEl, next);
    } else if (e.target.closest('[data-cart-remove]')) {
      applyLineChange(itemEl, 0);
    }
  });

  body?.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    const itemEl = input.closest('[data-cart-item]');
    if (!itemEl) return;
    const qty = Math.max(0, Math.floor(Number(input.value) || 0));
    input.value = String(qty);
    // Debounce typing
    const prev = debounceTimers.get(itemEl);
    if (prev) clearTimeout(prev);
    const t = setTimeout(() => applyLineChange(itemEl, qty), 220);
    debounceTimers.set(itemEl, t);
  });

  // Expose API
  window.FBCart = { open, close, refresh, openAfterAdd };

  // Prime the drawer contents on page load so the first open is instant
  // (only if cart is non-empty per server-rendered initial markup — if empty
  // the initial markup is already correct).
  if (root.querySelector('[data-cart-drawer-items]')) {
    // Refresh in the background to sync with any cross-tab changes
    setTimeout(refresh, 300);
  }
})();

/* =========================================================
   v4.8 — Cart drawer discount code
   Expand/collapse the Discounts panel and apply promo codes
   via Shopify's /discount/<code> endpoint. Whatever rule the
   merchant configures in Admin → Discounts will then apply at
   checkout (and across the cart). The code is also carried
   over via the cart attribute so it survives page reloads.
   ========================================================= */
(function () {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  var wrap     = root.querySelector('[data-cart-discount]');
  var toggle   = root.querySelector('[data-cart-discount-toggle]');
  var panel    = root.querySelector('[data-cart-discount-panel]');
  var input    = root.querySelector('[data-cart-discount-input]');
  var applyBtn = root.querySelector('[data-cart-discount-apply]');
  var msgEl    = root.querySelector('[data-cart-discount-msg]');
  if (!wrap || !toggle || !panel || !input || !applyBtn) return;

  function setMsg(text, state) {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.className = 'cart-discount__msg' + (state ? ' cart-discount__msg--' + state : '');
  }

  function openPanel() {
    panel.hidden = false;
    wrap.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () { try { input.focus(); } catch (_) {} }, 30);
  }
  function closePanel() {
    panel.hidden = true;
    wrap.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    if (wrap.classList.contains('is-open')) closePanel();
    else openPanel();
  });

  async function applyCode(code) {
    code = String(code || '').trim();
    if (!code) {
      setMsg('Enter a code first.', 'error');
      return;
    }
    applyBtn.setAttribute('aria-disabled', 'true');
    applyBtn.textContent = 'Applying…';
    setMsg('', null);

    try {
      // Step 1: ping /discount/<code> — this is Shopify's built-in endpoint that
      // stores the code on the cart and validates it against Admin → Discounts.
      // We request it with no-cors so Shopify accepts the redirect silently.
      await fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow',
      });

      // Step 2: mirror the code onto the cart as an attribute so it persists
      // for the session and is visible everywhere (including the full cart page).
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { 'Discount code': code } }),
      });

      setMsg('Code “' + code + '” will be applied at checkout.', 'success');
      input.value = '';

      if (window.FBCart && typeof window.FBCart.refresh === 'function') {
        window.FBCart.refresh();
      }
    } catch (_) {
      setMsg('We couldn’t apply that code. Try again.', 'error');
    } finally {
      applyBtn.removeAttribute('aria-disabled');
      applyBtn.textContent = 'Apply';
    }
  }

  applyBtn.addEventListener('click', function () { applyCode(input.value); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyCode(input.value);
    }
  });
})();

/* =========================================================
   v4.10 — Featured products: mobile carousel controls
   CSS handles the native swipe scrolling + scroll-snap.
   This JS only adds:
     • prev / next arrow button behaviour
     • dot indicators synced to current card
     • enable/disable state for arrows at the edges
   All of it is only meaningful on mobile (controls are hidden
   via CSS ≥641px) but the JS is cheap and harmless on desktop.
   ========================================================= */
(function () {
  var carousels = document.querySelectorAll('[data-product-carousel]');
  if (!carousels.length) return;

  carousels.forEach(function (root) {
    var track = root.querySelector('[data-product-carousel-track]');
    var prev  = root.querySelector('[data-product-carousel-prev]');
    var next  = root.querySelector('[data-product-carousel-next]');
    var dotsWrap = root.querySelector('[data-product-carousel-dots]');
    if (!track) return;

    var cards = Array.prototype.filter.call(track.children, function (el) {
      // Skip any empty / placeholder cards in the layout.
      return !el.classList.contains('product-card--empty');
    });
    if (!cards.length) return;

    // Build dot indicators (one per card).
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to product ' + (i + 1));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () { scrollToIndex(i); });
        dotsWrap.appendChild(dot);
      });
    }

    function currentIndex() {
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - trackCenter);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function scrollToIndex(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      var card = cards[i];
      if (!card) return;
      // Use inline 'center' so the target card ends up centred in the viewport.
      if (typeof card.scrollIntoView === 'function') {
        card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } else {
        track.scrollLeft = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
      }
    }

    function updateState() {
      var i = currentIndex();
      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('.product-carousel__dot');
        dots.forEach(function (d, idx) {
          d.setAttribute('aria-selected', idx === i ? 'true' : 'false');
        });
      }
      // Arrow disabled state at the edges (using aria-disabled so keyboard still reaches them
      // but CSS styles them as inactive).
      var atStart = track.scrollLeft <= 2;
      var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prev) prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', atEnd   ? 'true' : 'false');
    }

    if (prev) prev.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); });

    // Debounced scroll listener keeps dots + arrow states in sync during swipes.
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) window.cancelAnimationFrame(scrollTimer);
      scrollTimer = window.requestAnimationFrame(updateState);
    }, { passive: true });

    // Initial state — wait a tick so layout is settled.
    setTimeout(updateState, 50);
    window.addEventListener('resize', updateState);
  });
})();

/* v9.1 — footer dropdowns: only one open at a time.
   Any <details class="site-footer__col--collapsible"> that opens closes its
   siblings. Uses the `toggle` event so it also fires when the user opens a
   dropdown via keyboard. */
(function () {
  var groups = document.querySelectorAll('.site-footer__cols');
  groups.forEach(function (group) {
    var items = group.querySelectorAll('details.site-footer__col--collapsible');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  });
})();

/* ---------------------------------------------------------
   v13.3 — Fully sticky announcement + header.

   Shopify renders the announcement section and the header
   section as two flat siblings under <body> (both marked
   .shopify-section-group-header-group). Neither can be
   pinned individually and still keep the other in view.

   This script wraps them in a single <div
   data-fb-sticky-header> once the DOM is ready. CSS then
   pins that wrapper to the top of the viewport, so the
   announcement bar and header move as one and both stay
   visible while the user scrolls.

   Runs on every template. Safe to run twice: if the wrapper
   already exists, it is left alone. Also exposes
   --fb-sticky-h on <html> so any in-page sticky sub-header
   (e.g. store-locator search) can sit below the pinned bars.
   --------------------------------------------------------- */
(function () {
  var root = document.documentElement;
  var WRAPPER_ATTR = 'data-fb-sticky-header';
  var GROUP_SELECTOR = '.shopify-section-group-header-group';

  function ensureWrapper() {
    if (document.querySelector('[' + WRAPPER_ATTR + ']')) return;
    var groupSections = Array.from(document.querySelectorAll(GROUP_SELECTOR));
    if (groupSections.length === 0) return;
    // Only wrap contiguous sibling group members that share the same parent
    // and start at the top of that parent. This guards against unexpected
    // DOM layouts (e.g. sections re-parented into a drawer).
    var parent = groupSections[0].parentNode;
    if (!parent) return;
    var siblings = [];
    for (var i = 0; i < groupSections.length; i++) {
      var el = groupSections[i];
      if (el.parentNode !== parent) break;
      siblings.push(el);
    }
    var wrapper = document.createElement('div');
    wrapper.setAttribute(WRAPPER_ATTR, '');
    parent.insertBefore(wrapper, siblings[0]);
    siblings.forEach(function (s) { wrapper.appendChild(s); });
  }

  function measure() {
    var wrapper = document.querySelector('[' + WRAPPER_ATTR + ']');
    var h = wrapper ? Math.round(wrapper.getBoundingClientRect().height) : 0;
    root.style.setProperty('--fb-sticky-h', h + 'px');
  }

  function scheduleMeasure() {
    if (window.requestAnimationFrame) window.requestAnimationFrame(measure);
    else measure();
  }

  function init() {
    ensureWrapper();
    scheduleMeasure();
    if ('ResizeObserver' in window) {
      var wrapper = document.querySelector('[' + WRAPPER_ATTR + ']');
      if (wrapper) new ResizeObserver(scheduleMeasure).observe(wrapper);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(scheduleMeasure).catch(function () {});
  }
  window.addEventListener('load', scheduleMeasure);
  window.addEventListener('resize', scheduleMeasure);
  window.addEventListener('orientationchange', scheduleMeasure);

  // Shopify theme editor re-renders sections on edit. Re-run so the
  // wrapper is re-applied when the merchant tweaks header settings.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    // Unwrap on unload so Shopify can re-render cleanly, then rewrap
    // on the following load event.
    var wrapper = document.querySelector('[' + WRAPPER_ATTR + ']');
    if (wrapper && wrapper.parentNode) {
      while (wrapper.firstChild) wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
      wrapper.parentNode.removeChild(wrapper);
    }
  });
})();
